import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Badge, Col, Container, Row } from 'reactstrap'
import FeatherIcon from 'feather-icons-react'
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/scss/modal-video.scss'
import ImageFeatures from '../../assets/images/v2/features.jpg'
import ImageHighlight from '../../assets/images/v2/Highlight.png'
import ImageChrome from '../../assets/images/chrome.png'
import ImageFirefox from '../../assets/images/firefox.png'
import ImageEdge from '../../assets/images/edge.png'

const installLinks = [
  {
    name: 'Chrome',
    href: 'https://chrome.google.com/webstore/detail/highvocab-vocabulary-buil/nmalijlbcckplnamalenpdaafacfeemd?hl=en',
    image: ImageChrome,
  },
  {
    name: 'Edge',
    href: 'https://microsoftedge.microsoft.com/addons/detail/highvocab-vocabulary-bui/dfpolnmicooilcndegandafkmooecmei',
    image: ImageEdge,
  },
  {
    name: 'Firefox',
    href: 'https://addons.mozilla.org/en-US/firefox/addon/highvocab-vocabulary-builder/',
    image: ImageFirefox,
  },
]

const promisePoints = [
  'Capture useful words without leaving the page',
  'Understand them instantly with meaning, audio, and examples',
  'Remember more through repeated exposure and quick review',
]

const Section = () => {
  const [open, setOpen] = useState(false)
  const [videoId, setVideoId] = useState('')

  const openModal = (id) => {
    setVideoId(id)
    setOpen(true)
  }

  return (
    <section
      className="bg-half-170 border-bottom d-table w-100 extension-hero"
      id="home"
    >
      <Container>
        <Row className="align-items-center gy-5">
          <Col lg={6}>
            <div className="title-heading">
              <Badge pill className="extension-eyebrow extension-badge">
                Browser extension for effortless vocabulary growth
              </Badge>
              <h1 className="heading mb-3 mt-4">
                Turn everyday browsing into effortless vocabulary growth.
              </h1>
              <p className="para-desc text-muted">
                Save words from any page, understand them instantly, and see
                them again while you browse so new vocabulary sticks with far
                less effort.
              </p>

              <ul className="list-unstyled extension-check-list">
                {promisePoints.map((item) => (
                  <li key={item}>
                    <span className="extension-check-icon">
                      <FeatherIcon icon="check" size={16} />
                    </span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="extension-install-buttons">
                {installLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-primary extension-install-btn"
                  >
                    <img src={link.image} alt={link.name} />
                    Install on {link.name}
                  </a>
                ))}
              </div>

              <div className="extension-hero-foot">
                <div className="extension-hero-meta">
                  <span className="extension-meta-pill">Free plan available</span>
                  <span className="extension-meta-pill">
                    Chrome, Edge, and Firefox
                  </span>
                </div>
                <div className="extension-video-links">
                  <Link
                    to="#"
                    onClick={() => openModal('VW8W350kY1w')}
                    className="extension-video-link"
                  >
                    <FeatherIcon icon="play-circle" size={18} />
                    Product tour
                  </Link>
                  <Link
                    to="#"
                    onClick={() => openModal('cRfNrdFg7xw')}
                    className="extension-video-link"
                  >
                    <FeatherIcon icon="video" size={18} />
                    How it works
                  </Link>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className="extension-hero-visual">
              <div className="extension-hero-card extension-hero-main">
                <img
                  src={ImageFeatures}
                  className="img-fluid section-image"
                  alt="HighVocab browser extension preview"
                />
              </div>

              <div className="extension-hero-card extension-hero-float extension-hero-float-left">
                <div className="extension-mini-card-header">
                  <span className="extension-dot"></span>
                  Inline word help
                </div>
                <img
                  src={ImageHighlight}
                  className="img-fluid"
                  alt="Highlighted saved words in HighVocab"
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <ModalVideo
        channel="youtube"
        isOpen={open}
        videoId={videoId}
        onClose={() => setOpen(false)}
      />
    </section>
  )
}

export default Section
